import { CardsTableCell } from './CardsTableCell';
export default CardsTableCell;
